(function countdownTimer() {
    var jsTimer = document.querySelector('.js-timer-hours');
    if (jsTimer) {
        var second = 1000, minute = second * 60, hour = minute * 60, day = hour * 24;
        var countDown = new Date('November 29, 22 10:00 GMT+01:00').getTime(), x = setInterval(function () {
            var now = new Date().getTime(), distance = countDown - now;
            // @ts-ignore
            document.querySelector('.js-timer-hours').innerText = Math.floor((distance % (day)) / (hour)),
                // @ts-ignore
                document.querySelector('.js-timer-minutes').innerText = Math.floor((distance % (hour)) / (minute));
            // @ts-ignore
            document.querySelector('.js-timer-seconds').innerText = Math.floor((distance % (minute)) / second);
        }, second);
    }
})();
